'use strict';

const React = require('react');


const Logo = () => {
    return (
        <div>
            <div className="blink-logo"></div>
            <h1 className="cover-heading">Blink</h1>
        </div>
    );
}


module.exports = Logo;
